import { Anchor, AnchorProps, Flex } from '@mantine/core';
import { IconExternalLink } from '@tabler/icons-react';
import { ComponentProps, ReactNode } from 'react';

type LinkTextProps = AnchorProps & {
  children: ReactNode;
} & ComponentProps<'a'>;

export const LinkText = (props: LinkTextProps) => {
  const { children, ...rest } = props;

  return (
    <Anchor {...rest}>
      <Flex gap={5}>
        {children}
        <IconExternalLink
          size={12}
          style={{ display: 'inline', verticalAlign: 'middle' }}
        />
      </Flex>
    </Anchor>
  );
};
